import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeDeleteReturnOrdersParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [반품 신청/조회] 반품 취소 api 요청 훅
 */
const useDeleteReturnOrders = () => {
  const { runAsync } = useAsyncHandler();

  const deleteReturnOrders = useAPI<TypeDeleteReturnOrdersParams>({
    endpoint: API_ENDPOINT.CLAIM.DELETE_RETURN_ORDERS,
    method: 'delete',
  });

  const requestDeleteReturnOrders = async (
    { returnReceiptId }: TypeDeleteReturnOrdersParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => deleteReturnOrders({ pathParams: `/${returnReceiptId}` }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestDeleteReturnOrders };
};

export default useDeleteReturnOrders;
